import { gql } from '@apollo/client';

export const GQL_GET_ANALYTICS_USERS_ALLDAY_IN_YEAR = gql`
  query getAllTimeNewAnalyticsUsersAllDayInYear($startDate: String, $endDate: String) {
  getAllTimeNewAnalyticsUsersAllDayInYear (startDate: $startDate, endDate: $endDate) {
    items {
        id
        userId
        tpvCount
        trxCount
        day
        month
        createdAt
        updateAt
    }    
  }
}
`;

export const GQL_GET_ANALYTICS_USERS_LAST_30_DAYS = gql`
  query getAllTimeNewAnalyticsUsersLast30Days($currentDate: String) {
  getAllTimeNewAnalyticsUsersLast30Days (currentDate: $currentDate) {
    items {
      id
      userId
      tpvCount
      trxCount
      month
      day
      createdAt
      updateAt
    }
  }
}
`;

export const GQL_GET_ANALYTICS_USERS = gql`
  query getAllTimeNewAnalyticsUsers {
  getAllTimeNewAnalyticsUsers {
    id
    userId
    tpvCount
    trxCount
    day
    month
    createdAt
    updateAt
  }
} 
`;
